class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.querySelector('[data-cart-notification]');
    this.closeButton = this.notification.querySelector('[data-cart-notification-close]');
    this.body = document.querySelector('body');
    this.isOpen = false;

    this.closeButton.addEventListener('click', this.close.bind(this));
    this.notification.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
    this.body.addEventListener('cart-updated', (event) => {
      this.renderContents(event.detail);
    });
  }

  renderContents(parsedState) {
    this.notification.classList.add('animate', 'active');
    this.isOpen = true;

    const cartProduct = parsedState.items[0];

    this.notification.querySelector('[data-product-title]').textContent = cartProduct.title;
    this.notification.querySelector('[data-product-image]').setAttribute('src', cartProduct.image);
    this.notification.querySelector('[data-product-image]').setAttribute('alt', cartProduct.title);

    this.notification.classList.remove('hidden');
  }

  close() {
    if (!this.isOpen) return;

    this.notification.classList.add('closing');
    setTimeout(() => {
      this.notification.classList.remove('active', 'animate', 'closing');
      this.notification.classList.add('hidden');
      this.isOpen = false;
    }, 300);
  }
}

customElements.define('cart-notification', CartNotification);